import React, { Component } from 'react'
import { connect } from 'react-redux';
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom';
import _ from 'lodash';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { getData } from '../../../redux-store/actions';
import {
  CORREDOR_GP_CHANGE_FILTER_DATE,
  GP_GET_TIPOS_ENDOSO,
  POL_GET_MONEDAS,
  POL_GET_TIPOS_COBERTURA,
} from '../../../redux-store/constants/action-types';
import { API, BACKEND_DF, BASE_URL, FRONT_DF_1, SEARCH_DELAY_MS } from '../../../CONST';
import {
  cellDateOperation,
  cellDobleRowOperation,
  cellNumOperation,
  cellOperation,
  headerDoubleRowOperation,
  headerOperation
} from '../../../helpers/tables';
import BaseTable from '../../shared/BaseTable';
import FilterSelect from '../../shared/FilterSelect';
import { objectsToOptions } from '../../../helpers/selects';
import DownloadBtn from '../../shared/DownloadBtn';
import CorredorEndosoSummary from '../CorredorEndosoSummary';
import { getPolicies } from '../../../redux-store/actions/corredorGarantia';
import MonthRangeFilter from '../../shared/MonthRangeFilter';

const NO_FILTERED_ID = -1;

class CorredorGarantiaPolicyList extends Component {

  constructor(props) {
    super(props);
    this.filtering = false;
    this.filterParams = '';
    this.fetchDataWithDebounce = _.debounce(this.fetchData, SEARCH_DELAY_MS);
    this.tableRef = React.createRef();
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(getData({
      url: `${BASE_URL}${API.monedas}/`,
      type: POL_GET_MONEDAS,
    }));
    dispatch(getData({
      url: `${BASE_URL}${API.tiposCobertura}/?tipo_poliza=garantia`,
      type: POL_GET_TIPOS_COBERTURA,
    }));
    dispatch(getData({
      url: `${BASE_URL}${API.tiposEndosoGarantia}/`,
      type: GP_GET_TIPOS_ENDOSO,
    }));
  }

  componentDidUpdate(prevProps) {
    const {
      datesFilter: { startDate: prevStartDate, endDate: prevEndDate },
      corredor: prevCorredor,
    } = prevProps;
    const { datesFilter: { startDate, endDate }, corredor } = this.props;

    const datesChanged = startDate !== prevStartDate || endDate !== prevEndDate
    const corredorChanged = JSON.stringify(prevCorredor) !== JSON.stringify(corredor)

    if ((datesChanged || corredorChanged) && this.tableRef.current) {
      this.fetchStrategy(this.tableRef.current.state);
    }
  }

  onFilteredChange = () => {
    this.filtering = true;
  };

  fetchStrategy = (tableState) => {
    if (this.filtering) {
      return this.fetchDataWithDebounce(tableState);
    }
    return this.fetchData(tableState);
  };

  fetchData = (state) => {
    const { dispatch, datesFilter: { startDate, endDate }, user, corredor } = this.props;
    this.filtering = false;

    const dateFilter = `desde_ano=${startDate.year()}&desde_mes=${startDate.month() + 1}&hasta_ano=${endDate.year()}&hasta_mes=${endDate.month() + 1}`;
    let filterParams = `page=${state.page + 1}&${dateFilter}&`;

    if (user.is_orsan && corredor) {
      filterParams = `${filterParams}corredor_id=${corredor.id}&`
    }

    if (state.filtered.length) {
      state.filtered.forEach((node) => {
        let validFilter = false;
        let filterValue = node.value;

        if (typeof node.value === 'number' && node.value > 0) {
          validFilter = true;
        } else if (typeof node.value === 'string' && node.value.length > 2 && node.value !== 'all-options') {
          validFilter = true;

          const dateFields = [ 'emision' ];
          if (dateFields.includes(node.id)) {
            const date = moment(filterValue, FRONT_DF_1, true);
            if (date.isValid()) {
              filterValue = date.format(BACKEND_DF);
            } else {
              validFilter = false;
            }
          }
        }
        if (validFilter) {
          filterParams = `${filterParams}${node.id}=${filterValue}&`;
        }
      });
    }

    // only fetch data if filters have changed
    if (filterParams !== this.filterParams) {
      this.filterParams = filterParams;
      dispatch(getPolicies(filterParams));
    }
  };

  render() {
    const {
      dispatch, user, loading, endosos, summary,
      poliza: { monedas, tiposCobertura },
      datesFilter, xlsxUrl, pdfUrl, tiposEndoso,
    } = this.props;

    if (monedas.length === 0 || tiposCobertura.length === 0) {
      return null
    }

    const monedasOptions = objectsToOptions(monedas, 'nombre_corto', true);
    const tiposEndosoOptions = objectsToOptions(tiposEndoso, 'descripcion', true);
    const tiposCoberturaOptions = objectsToOptions(tiposCobertura, 'descripcion', true);
    const columns = [
      {
        Header: headerOperation('Código'),
        id: 'poliza_base__base__nemotecnico__icontains',
        accessor: i => cellOperation(i.nemotecnico),
        minWidth: 120,
        sortable: false,
      },
      {
        Header: headerOperation('Afianzado'),
        id: 'poliza_base__afianzado',
        accessor: i => cellDobleRowOperation(i.afianzado.rut, i.afianzado.nombre),
        minWidth: 200,
        sortable: false,
      },
      {
        Header: headerOperation('Asegurado'),
        id: 'poliza_base__base__asegurado',
        accessor: i => cellDobleRowOperation(i.asegurado.rut, i.asegurado.nombre),
        minWidth: 200,
        sortable: false,
      },
      {
        Header: headerOperation('Cobertura'),
        id: 'poliza_base__base__tipo_cobertura_id',
        accessor: i => cellOperation(i.cobertura, 'left'),
        Filter: obj => (
          <FilterSelect
            filter={obj.filter}
            defaultOption={{ label: 'Todos', value: NO_FILTERED_ID }}
            onFilterChange={obj.onChange}
            options={tiposCoberturaOptions}
          />
        ),
        minWidth: 200,
        sortable: false,
      },
      {
        Header: headerDoubleRowOperation('Fecha', 'Emisión'),
        id: 'emision',
        accessor: i => cellDateOperation(i.emision),
        sortable: false,
        minWidth: 100,
      },
      {
        Header: headerOperation('Tipo Endoso'),
        id: 'tipo_endoso_id',
        accessor: i => cellOperation(i.tipo_endoso.descripcion),
        Filter: obj => (
          <FilterSelect
            onFilterChange={obj.onChange}
            filter={obj.filter}
            options={tiposEndosoOptions}
            defaultOption={{ label: 'Todos', value: NO_FILTERED_ID }}
          />
        ),
        minWidth: 120,
        sortable: false,
      },
      {
        Header: headerOperation('Moneda'),
        id: 'poliza_base__base__moneda_asegurada_id',
        accessor: i => cellOperation(i.moneda),
        Filter: obj => (
          <FilterSelect
            onFilterChange={obj.onChange}
            filter={obj.filter}
            options={monedasOptions}
            defaultOption={{ label: 'Todas', value: NO_FILTERED_ID }}
          />
        ),
        sortable: false,
        minWidth: 100,
      },
      {
        Header: headerDoubleRowOperation('Monto', 'Garantizado'),
        id: 'cobertura',
        accessor: i => cellNumOperation(i.cambio_cobertura_amt),
        minWidth: 120,
        filterable: false,
        sortable: false,
      },
      {
        Header: headerOperation('Prima Neta'),
        id: 'prima',
        accessor: i => cellNumOperation(i.cambio_prima_neta_amt, 'float'),
        minWidth: 100,
        filterable: false,
        sortable: false,
      },
      {
        Header: headerOperation('% comisión'),
        id: 'comision_pct',
        accessor: i => cellNumOperation(i.cambio_comision_pct, 'float'),
        minWidth: 100,
        filterable: false,
        sortable: false,
      },
      {
        Header: headerOperation('Comisión'),
        id: 'comision',
        accessor: i => cellNumOperation(i.cambio_comision_pct * i.cambio_prima_neta_amt / 100, 'float'),
        minWidth: 100,
        filterable: false,
        sortable: false,
      },
      {
        Header: headerOperation('Acciones'),
        id: 'actions',
        accessor: i => (
          <div
            className="table-cell"
            style={{ textAlign: 'center' }}
          >
            <span title="ver">
              <Link
                to={`/corredor/polizas-garantia/${i.poliza_base}`}
                className="table-link policy"
              >
                <FontAwesomeIcon icon={faEye} />
              </Link>
            </span>
          </div>
        ),
        filterable: false,
        sortable: false,
        minWidth: 90,
      },
    ];
    return (
      <>
        <div style={{ display: 'grid', gridTemplateColumns: '500px 700px', alignItems: 'start' }}>
          <div
            style={{
              display: 'grid', gridTemplateColumns: '65px auto', gridGap: '4px 15px',
              padding: '0 0 16px 16px', alignItems: 'center',
            }}
          >
            {!user.is_orsan && (
              <>
                <div className="orsan-label">Nombre:</div>
                <div className="orsan-value">{user.organization_name}</div>
                <div className="orsan-label">RUT:</div>
                <div className="orsan-value">{user.organization_rut}</div>
              </>
            )}
            <div className="orsan-label">Desde:</div>
            <MonthRangeFilter
              dispatch={dispatch}
              datesFilter={datesFilter}
              changeDateActionName={CORREDOR_GP_CHANGE_FILTER_DATE}
            />
          </div>
          <div>
            <CorredorEndosoSummary
              data={summary}
              columns={[
                { title: 'Moneda', accessor: 'moneda', format: 'string' },
                { title: 'Monto Garantizado Período', accessor: 'monto_garantizado', format: 'number', cellAlign: 'right' },
                { title: 'Prima Neta Período', accessor: 'prima_neta', format: 'number', cellAlign: 'right' },
                { title: 'Comisión Período', accessor: 'comision_generada', format: 'number', cellAlign: 'right' },
              ]}
            />
          </div>
        </div>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr auto auto',
            gridGap: '10px',
            marginTop: '15px',
            marginBottom: '6px',
          }}
        >
          <div style={{ gridColumnStart: 2 }}>
            <DownloadBtn
              id='xlsx-download'
              text='XLSX'
              tipText='Descargar Planilla Excel'
              url={xlsxUrl}
            />
          </div>
          <div style={{gridColumnStart: 3}}>
            <DownloadBtn
              id='pdf-download'
              text='PDF'
              tipText='Descargar PDF'
              disabled={!pdfUrl}
              url={pdfUrl}
            />
          </div>
        </div>
        <BaseTable
          tableRef={this.tableRef}
          columns={columns}
          data={endosos.data}
          filterable
          loading={loading}
          onFetchData={this.fetchStrategy}
          onFilteredChange={this.onFilteredChange}
          pages={endosos.pages}
          resultCount={endosos.count}
          showPagination
          style={{ maxHeight: '63vh' }}
        />
      </>
    );
  }
}

CorredorGarantiaPolicyList.propTypes = {
  dispatch: PropTypes.func.isRequired,
  endosos: PropTypes.shape({
    data: PropTypes.array,
    pages: PropTypes.number,
    count: PropTypes.number,
  }).isRequired,
  xlsxUrl: PropTypes.string.isRequired,
  pdfUrl: PropTypes.string.isRequired,
  datesFilter: PropTypes.shape({
    startDate: PropTypes.instanceOf(moment),
    endDate: PropTypes.instanceOf(moment),
  }).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  summary: PropTypes.array,
  poliza: PropTypes.shape({
    monedas: PropTypes.array,
    tiposCobertura: PropTypes.array,
  }).isRequired,
  user: PropTypes.shape({
    organization_name: PropTypes.string,
    organization_rut: PropTypes.string,
    is_orsan: PropTypes.bool,
  }).isRequired,
  loading: PropTypes.bool.isRequired,
  tiposEndoso: PropTypes.arrayOf(
    PropTypes.shape({
      descripcion: PropTypes.string,
    }),
  ).isRequired,
  corredor: PropTypes.shape({
    id: PropTypes.number,
  })
};

CorredorGarantiaPolicyList.defaultProps = {
  summary: null,
  corredor: null,
};

const mapStateToProps = state => ({
  endosos: state.corredorGarantia.list.endosos,
  tiposEndoso: state.corredorGarantia.tiposEndoso,
  xlsxUrl: state.corredorGarantia.list.xlsxUrl,
  pdfUrl: state.corredorGarantia.list.pdfUrl,
  datesFilter: state.corredorGarantia.list.datesFilter,
  summary: state.corredorGarantia.list.summary,
  loading: state.corredorGarantia.loading,
  poliza: state.poliza,
  user: state.login.user,
});

export default connect(mapStateToProps)(CorredorGarantiaPolicyList);
